import 'flatpickr/dist/themes/dark.css';
import { BaseOptions } from 'flatpickr/dist/types/options';
import * as React from 'react';
import Flatpickr, { DateTimePickerProps } from 'react-flatpickr';
import { formatDay, formatDayFromUtc, formatToday } from '../../../utils/date';
import { Input } from './Input';

interface ICustomInputProps extends DateTimePickerProps {
  inputRef: React.Ref<HTMLInputElement>;
}

const CustomInput = ({
  value,
  disabled,
  inputRef,
  defaultValue,
}: ICustomInputProps): React.ReactElement => {
  return (
    <Input
      ref={inputRef}
      value={defaultValue as string}
      disabled={disabled}
      readOnly
    />
  );
};

interface IProps {
  maxDate?: string;
  minDate?: string;
  local?: boolean;
}

export const DateInput = (
  props: DateTimePickerProps & IProps
): React.ReactElement => {
  const inputValue: string = props.local
    ? formatDay(props.value as number)
    : formatDayFromUtc(props.value as number);

  const getOptions = (): Partial<BaseOptions> => {
    return {
      dateFormat: 'm/d/y',
      maxDate: props.maxDate ? props.maxDate : formatToday(),
      minDate: props.minDate ? props.minDate : '12/31/16',
    };
  };

  return (
    <Flatpickr
      disabled={props.disabled}
      className='hd-date-picker'
      value={inputValue !== 'Invalid Date' ? inputValue : undefined}
      onChange={props.onChange}
      options={getOptions()}
      render={(
        { defaultValue, value }: DateTimePickerProps,
        ref: React.Ref<HTMLInputElement>
      ): React.ReactElement => {
        return (
          <CustomInput
            defaultValue={defaultValue}
            disabled={props.disabled}
            inputRef={ref}
            value={value}
            {...props}
          />
        );
      }}
    />
  );
};
